import React from 'react';
import Item from "../../components/portfolio/Item";

const ContactMe = () => {
  return (
    <div className="ui">
      <div className="ui internally stackable grid">
        <div className="row"></div>
        <div className="row">
          <div className="three wide column"></div>
          <div className="ten wide column">
            <h3>Where to find me?</h3>
            <div className="ui list">
              <Item
                  title="Linkedin"
                  description="Add me on Linkedin!"
                  icon="linkedin"
                  href="https://www.linkedin.com/in/danielperezlorenzo/"
              />
              <Item
                  title="Github"
                  description="Most of my projects are private, but you might find something"
                  icon="github"
                  href="https://github.com/shake93"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactMe;